import { ConditionField, DimensionDescriptor } from "../../../../../../shared/reporting/api/biClient.types";
import { MeasureDataset } from "../../../../../api/biApi.types";
import { FormulaNode } from "../utilities/fillNodes";
import { INode } from "../utilities/formulaParser";
import { Token } from "../utilities/tokenizer";
import { CustomMeasureState } from "./customMeasure.types";

export enum CustomMeasureActionType {
  UPDATE = "UPDATE",
  SET_ROOTNODE = "SET_ROOTNODE",
  UPDATE_FORMULA_NODE = "UPDATE_FORMULA_NODE",
  UPDATE_DATASET = "UPDATE_DATASET",
  UPDATE_DIMENSIONS = "UPDATE_DIMENSIONS",
  ADD_CONDITIONS = "ADD_CONDITIONS",
  UPDATE_CONDITION = "UPDATE_CONDITION",
  REMOVE_CONDITION = "REMOVE_CONDITION",
  HIGHLIGHT_NODE = "HIGHLIGHT_NODE",
  FUNCTION_HOVERED = "FUNCTION_HOVERED",
  FOCUS_FORMULA_INPUT = "FOCUS_FORMULA_INPUT",
  FORMULA_PARAMETER_CLICK = "FORMULA_PARAMETER_CLICK",
  SET_DATASETS = "SET_DATASETS",
}

export type UpdateAction = {
  type: CustomMeasureActionType.UPDATE;
  payload: Partial<CustomMeasureState>;
};

export type UpdateDimensionsAction = {
  type: CustomMeasureActionType.UPDATE_DIMENSIONS;
  payload: { dimensions: DimensionDescriptor[] };
};

export type SetRootAction = {
  type: CustomMeasureActionType.SET_ROOTNODE;
  payload?: INode;
};

export type UpdateFormulaNodeAction = {
  type: CustomMeasureActionType.UPDATE_FORMULA_NODE;
  payload: { node: FormulaNode; changes: Partial<FormulaNode> };
};

export type AddConditionsAction = {
  type: CustomMeasureActionType.ADD_CONDITIONS;
  payload: { node: FormulaNode; newConditions: ConditionField[] };
};

export type UpdateConditionAction = {
  type: CustomMeasureActionType.UPDATE_CONDITION;
  payload: { node: FormulaNode; condition: ConditionField; changes: Partial<ConditionField> };
};

export type RemoveConditionAction = {
  type: CustomMeasureActionType.REMOVE_CONDITION;
  payload: { node: FormulaNode; condition: ConditionField };
};

export type HighlightNodeAction = {
  type: CustomMeasureActionType.HIGHLIGHT_NODE;
  payload: Token | undefined;
};

export type FunctionHoverAction = {
  type: CustomMeasureActionType.FUNCTION_HOVERED;
  payload: Token | undefined;
};

export type FormulaParameterClickAction = {
  type: CustomMeasureActionType.FORMULA_PARAMETER_CLICK;
  payload: Token | undefined;
};

export type SetDataSetsAction = {
  type: CustomMeasureActionType.SET_DATASETS;
  payload: MeasureDataset[];
};

export type Actions =
  | UpdateAction
  | UpdateDimensionsAction
  | SetRootAction
  | UpdateFormulaNodeAction
  | AddConditionsAction
  | UpdateConditionAction
  | RemoveConditionAction
  | HighlightNodeAction
  | FunctionHoverAction
  | FormulaParameterClickAction
  | SetDataSetsAction;
